import React, { useEffect, useMemo, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { Button, Spin, Typography, notification } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import { ChallengeForm } from './ChallengeForm';
import { ChallengesProxy } from '../services/catalogServiceAPI/challengesProxy';
import { isoToUtcInput } from '../utils/dateFormatting';
import { config } from '../../config';

export function EditChallenge() {
    const { id } = useParams();
    const history = useHistory();
    const [challenge, setChallenge] = useState(null);
    const [loading, setLoading] = useState(true);
    const proxy = useMemo(() => new ChallengesProxy(), []);

    useEffect(() => {
        proxy.get(id)
            .then(c => setChallenge({ ...c, startDate: isoToUtcInput(c.startDate) }))
            .catch(e => notification.error({ message: 'Failed to load challenge', description: e.message }))
            .finally(() => setLoading(false));
    }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

    const submit = async (values) => {
        await proxy.update({ id, ...values });
        notification.success({ message: 'Challenge saved' });
        history.push('/challenges');
    };

    if (loading) return <div style={{ padding: 32 }}><Spin /></div>;
    if (!challenge) return <div style={{ padding: 32 }}>Challenge not found</div>;

    const previewUrl = `${config().clientBaseUrl}/editor?challenge=${id}&preview=1`;

    return (
        <div style={{ padding: '24px 32px', maxWidth: 900 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
                <Typography.Title level={3} style={{ margin: 0 }}>Edit challenge</Typography.Title>
                <Button
                    type="default"
                    icon={<EyeOutlined />}
                    href={previewUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Preview in editor
                </Button>
            </div>
            <ChallengeForm
                initialValues={challenge}
                onSubmit={submit}
                submitLabel="Save changes"
            />
        </div>
    );
}
